import { optionFromNullable } from 'io-ts-types/es6/optionFromNullable';
import { literal, number, type, union } from 'io-ts/es6/index';
const RemoteInitialCodec = type({
    _tag: literal('RemoteInitial'),
});
const RemoteProgressCodec = type({
    loaded: number,
    total: optionFromNullable(number),
});
const RemotePendingCodec = type({
    _tag: literal('RemotePending'),
    progress: optionFromNullable(RemoteProgressCodec),
});
export function createRemoteDataFromJSON(leftCodec, rightCodec) {
    const RemoteFailureCodec = type({
        _tag: literal('RemoteFailure'),
        error: leftCodec,
    });
    const RemoteSuccessCodec = type({
        _tag: literal('RemoteSuccess'),
        value: rightCodec,
    });
    return union([RemoteInitialCodec, RemotePendingCodec, RemoteFailureCodec, RemoteSuccessCodec], '_tag');
}
